import * as React from 'react';
import { Calendar } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Button } from 'components/ui/button';

export const CreateOrderButton = () => {
  const navigate = useNavigate();

  return (
    <Button
      variant="outline"
      size="sm"
      className="w-full max-w-full md:max-w-max h-8 font-GilroySemibold lg:flex bg-green-600 text-white hover:bg-green-500 hover:text-white duration-300"
      onClick={() => navigate('/agendamento/criar-solicitacao-estoque')}
    >
      <Calendar className="mr-2 h-4 w-4" />
      Nova Solicitação
    </Button>
  );
};
